import { render, staticRenderFns } from "./WebpageList.vue?vue&type=template&id=650bda72&scoped=true&"
import script from "./WebpageList.vue?vue&type=script&lang=js&"
export * from "./WebpageList.vue?vue&type=script&lang=js&"
import style0 from "./WebpageList.vue?vue&type=style&index=0&id=650bda72&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650bda72",
  null
  
)

export default component.exports